<div class="space-y-6">
  <app-page-header
    [backTo]="['/payment-methods', item()?.id ?? '']"
    backLabel="Retour à la fiche"
    title="Modifier la méthode"
    subtitle="Met à jour le PSP. Les champs marqués d'un astérisque sont obligatoires."
  />

  @if (loadError() || loading()) {
    <app-data-state
      [loading]="loading()"
      [error]="loadError()"
      loadingMessage="Chargement…"
      (retry)="fetch()"
    />
  } @else if (item(); as m) {
    <section class="rounded-2xl border border-gray-200 bg-white p-6 shadow-theme-xs dark:border-gray-800 dark:bg-white/[0.03]">
      <app-payment-method-form
        mode="edit"
        [initial]="m"
        [submitting]="submitting()"
        [serverError]="serverError()"
        (save)="onSave($event)"
        (cancel)="onCancel()"
      />
    </section>
  }
</div>
